const noDecimals = [
    'DZD', 'BDT', 'CLP', 'COP', 'CRC', 'CZK', 'DKK', 'GEL', 'GHS', 'HKD', 'HUF',
    'INR', 'IDR', 'IQD', 'JPY', 'JOD', 'KZT', 'KES', 'LBP', 'MMK', 'NGN', 'NOK',
    'PKR', 'PYG', 'PHP', 'RUB', 'RSD', 'KRW', 'LKR', 'SEK', 'TWD', 'TZS', 'THB',
    'VND'
];

export const getIntroPrice = (product, asFloat = false) => {
    try {
        if (typeof product.introductoryPrice === "undefined") return "";
        if (typeof product.introductoryPrice === "null") return "";
        // if (typeof product.introductoryPrice === "string") product.introductoryPrice = JSON.parse(product.introductoryPrice);

        // Handle fucked up data from flutter, todo: add proper json on nested objects!!!
        const regex = /(?:introPrice: )(.*)(?:, introPriceString:)/gm;
        const str = product.introductoryPrice;
        let price = "";
        let m;
        while ((m = regex.exec(str)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }

            // The result can be accessed through the `m`-variable.
            m.forEach((match, groupIndex) => {
                if(groupIndex === 1) price = match;
                // console.log(`Found match, group ${groupIndex}: ${match}`);
            });
        }
        if(isNaN(parseFloat(price))) return "";
        const parts = splitPrice(price);
        let priceWhole = parts[0];
        let priceDecimals = parts[1];


        window.Tracker.logEvent({
            event_name: "intro_price",
            event_category: "iap",
            event_label: priceWhole + (priceDecimals ? '.' + priceDecimals : '') + " " + product.currencyCode,
        });

        if (asFloat) return parseFloat(priceWhole + '.' + priceDecimals);
        return priceWhole + (priceDecimals ? '.' + priceDecimals : '') + " " + product.currencyCode;
    } catch (e) {
        window.captureException(e);
        return "";
    }
}

export const getProductPrices = (product, asFloat = false) => {
    try {
        let priceWhole = "";
        let priceDecimals = "";
        let priceWholeMonthly = "";
        let priceDecimalsMonthly = "";

        // version compatibility
        const priceData = localStorage.getItem('flutterVersion').startsWith('4') ? product.price : product.priceAsString;

        const parts = splitPrice(priceData);
        priceWhole = parts[0];
        priceDecimals = parts[1];

        if(product.period === 'annual') {
            const price = parseFloat(priceData)+0;
            const priceMonthly = (Math.ceil((price/12)*100))/100;
            const partsMonthly = splitPrice(priceMonthly);

            priceWholeMonthly = partsMonthly[0];

            if (noDecimals.includes(product.currencyCode)) priceDecimalsMonthly = "";
            else priceDecimalsMonthly = partsMonthly[1];
        }

        if (asFloat) return parseFloat(priceWhole + '.' + priceDecimals);
        return priceWhole + (priceDecimals ? '.' + priceDecimals : '') + " " + product.currencyCode;
    } catch(error) {
        captureException(error);
    }
}

const splitPrice = (price) => {
    try {
        price = parseFloat(price)+0;

        price = Math.round(price * 100) / 100;

        const parts = String(price).split(".");

        if (parts.length !== 2) {
            return([numberWithSpaces(price), ""]);
        }

        return([
            numberWithSpaces(parts[0]),
            String(parts[1]).replace(/^(\d{1})$/, "$10")
        ]);

    } catch(error) {
        captureException(error);
        console.error(error);
    }
}

const numberWithSpaces = (x) => {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
}
